export class BoundedQueue {
    constructor(options) {
        var _a;
        this.dropped = 0;
        this.maxSize = options.maxSize;
        this.dropPolicy = (_a = options.dropPolicy) !== null && _a !== void 0 ? _a : "drop-newest";
        this.items = [];
    }
    enqueue(item) {
        if (this.items.length >= this.maxSize) {
            if (this.dropPolicy === "drop-oldest") {
                this.items.shift();
                this.dropped += 1;
            }
            else {
                this.dropped += 1;
                return false;
            }
        }
        this.items.push(item);
        return true;
    }
    dequeue() {
        return this.items.shift();
    }
    peek() {
        return this.items[0];
    }
    size() {
        return this.items.length;
    }
    isFull() {
        return this.items.length >= this.maxSize;
    }
    clear() {
        this.items.length = 0;
    }
    getDroppedCount() {
        return this.dropped;
    }
    resetDroppedCount() {
        this.dropped = 0;
    }
}
